<template>
  <ErrorPageTemplate
    :errorCode="errorCode"
    :errorDescription="errorDescription"
  />
</template>

<script lang="ts">
export default {
  name: "NotFound",

  metaInfo() {
    return {
      titleTemplate: `%s - ${this.errorCode}`
    }
  },

  data() {
    return {
      errorCode: 404,
      errorDescription: this.$t("error_pages.not_found")
    }
  },

  components: {
    ErrorPageTemplate: () => import("@/components/ErrorPages/_components/ErrorPageTemplate")
  }
}
</script>
